import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import AddDeviceForm from '../components/AddDeviceForm';

const DeviceAdd = () => {
  return (
    <div>
      <NavbarTop />
      <AddDeviceForm />
      <NavbarBottom />
    </div>
  );
};

export default DeviceAdd;
